/*
 * @Author: your name
 * @Date: 2021-12-22 20:03:19
 * @LastEditTime: 2022-01-04 16:20:08
 * @LastEditors: your name
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: \app-child-manage\src\main.js
 */
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
// import Vconsole from 'vconsole'
// import network from './api/index'
import '../flexible'
import Vant, { Lazyload } from 'vant'
import './style/base.css'
import './assets/icon/iconfont.css'
import 'vant/lib/index.css'

import service from './services/index'
import './plugins/install'
import 'babel-polyfill'
import Es6Promise from 'es6-promise'
import Moment from 'moment'
import globalVariable from './utils/globalVariable.js'
import axios from 'axios'
import $ from 'jquery'
window.$ = $
// window.jQuery = jQuery;

require('es6-promise').polyfill()
Es6Promise.polyfill()
Vue.prototype.$axios = axios
// axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';
axios.defaults.baseURL = 'https://assistant-pad-test.eebbk.net/'
//axios.defaults.baseURL = 'https://assistant-pad.eebbk.net/'

Vue.use(Vant)
Vue.use(Lazyload, {
  lazyComponent: true
})

Vue.prototype.$moment = Moment
Vue.prototype.commonsVariable = globalVariable

Vue.filter('formatDate', function (value) {
  return Moment(value).format('YYYY-MM-DD HH:mm:ss')
})
// let vConsole = new Vconsole()
// Vue.use(vConsole)

// Vue.prototype.$api = network

Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  service,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js